export const getShowAddFeedback = (state) => {
	return state.showAddFeedback
}

export const getFeedbackList = (state) => {
    return state.feedbackList.data
}